import { withFieldHint } from "@/src/components/HighOrderComponents";
import { TextField } from "@/src/components/Fields/TextField";
import { useFormContext } from "react-hook-form";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";

const TextFieldWithHint = withFieldHint(TextField);

export function TextInput(props: any) {
  const { hint, name, ...restProps } = props;
  const hints = hint?.hintsList;
  const { control } = useFormContext();
  const debouncedUpdateField = useFieldDebouncedCallback(name);
  return (
    <TextFieldWithHint
      {...props}
      onChange={(e) => {
        props?.onChange?.(e);
        if (!e?.currentTarget?.closest('[role="dialog"]')) {
          debouncedUpdateField(e.target.value);
        }
      }}
      control={control}
      name={name}
      hints={hints}
    />
  );
}
